"use client";

import { useEffect } from "react";

export default function AppError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Surface as much detail as possible so prod issues are diagnosable from
    // the browser console. `digest` correlates with server-side Next.js logs.
    console.error("[AppError] Client-side exception", {
      name: error.name,
      message: error.message,
      stack: error.stack,
      digest: error.digest,
      url: typeof window !== "undefined" ? window.location.href : undefined,
      timestamp: new Date().toISOString(),
    });
  }, [error]);

  // Render nothing — the surrounding layout (header, sidebar, etc.) stays
  // mounted; only the failing segment is hidden. Avoids the default Next.js
  // "Application error: a client-side exception has occurred" overlay.
  return null;
}
